export default __webpack_public_path__ + "static/media/organs-and-skeleton.53ff93a4.svg";